module.exports = __webpack_public_path__ + "img/deposit.cc18956b.png";